import React, { Fragment, useState, useEffect } from "react";
import { Col, Card, CardHeader, CardBody, Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from "reactstrap";
import SweetAlert from "sweetalert2";
import DataTable from "react-data-table-component";
import { H3, Btn, Breadcrumbs } from "../../../AbstractElements";
import { useNavigate } from "react-router-dom";
import { deleteUser, getStaff } from "../../../CommonURL";
import { getDataWithToken, postDataWithToken } from "../../../Utils/restUtils";
import SearchList from "../../../CommonElements/Search";
import Transparentspinner from "../../Common/loader/Transparentspinner";
import { StaffColumns } from "../../../Data/MockTable/TableHeaderList";

const StaffList = () => {
  const [staffList, setStaffList] = useState([]);
  const [staffData, setStaffData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchKeyword, setSearchKeyword] = useState("");
  const [tempSearch, setTempSearch] = useState("");
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
  const toggleStyle = { padding: '10px 20px', opacity: '0.8', fontSize: '14px' };

  const navigate = useNavigate();


  useEffect(() => {
    fetchStaff();
  }, [searchKeyword]);

  const filteredItems = staffData.filter((item) =>
    (item.first_name + " " + item.last_name)
      .toLowerCase()
      .includes(searchKeyword.toLowerCase()),
  );

  const updateSearchKeyword = (keyword) => {
    setTempSearch(keyword);
  };
  const redirectToEditForm = (data) => {
  const editFormURL = `${process.env.PUBLIC_URL}/master-records/staff-edit?id=${data?.id}`;
  navigate(editFormURL);
};
const deleteStaffList = (userId) => {
  SweetAlert.fire({
    title: "Are you sure?",
    text: "Once deleted, you will not be able to recover this Staff!",
    icon: "warning",
    showCancelButton: true,
    confirmButtonText: "Ok",
    cancelButtonText: "cancel",
    reverseButtons: true,
  }).then(async (result) => {
    if (result.value) {
      setLoading(true);

      try {
        const deleteRes = { user_id: userId };

        const staffRemove = await postDataWithToken(
          deleteUser,
          deleteRes
        );

        if (staffRemove?.data?.status === true) {
          SweetAlert.fire(
            "Deleted!",
            "Staff has been deleted.",
            "success"
          );

          fetchStaff();
        } else {
          navigate(
            `${process.env.PUBLIC_URL}/pages/error/error-page4`
          );
        }
      } catch (error) {
        console.error(error);
      }

      setLoading(false);
    }
  });
};
    const ActionCell = ({ row }) => {
        const [dropdownOpen, setDropdownOpen] = React.useState(false);
        const toggleDropdown = () => setDropdownOpen(!dropdownOpen);

        return (
            <Dropdown isOpen={dropdownOpen} toggle={toggleDropdown}>
                <DropdownToggle color="#00000" style={{ fontSize: '14px', zIndex: 1000 }}>
                    <i className="fa fa-ellipsis-v"></i>
                </DropdownToggle>
                <DropdownMenu container="body"> 
                    <DropdownItem style={toggleStyle} onClick={() => redirectToEditForm(row)}>Edit</DropdownItem>
                    <DropdownItem style={{padding: '10px 20px', color: 'red', opacity: '0.8', fontSize: '14px', margin: '0'}} onClick={() => deleteStaffList(row.id)}>Delete</DropdownItem>
                </DropdownMenu>
            </Dropdown>
        );
    };
  const fetchStaff = async () => {
    setLoading(true);

    try {
      const res = await getDataWithToken(getStaff);
      const apiData = res?.data?.data || [];
      setStaffData(apiData);
      setResetPaginationToggle(!resetPaginationToggle);
      const source = searchKeyword ? filteredItems : apiData;
      const formattedData = source.map((e, index) => ({
        Si: index + 1,
        id: e.id,
        Name: (
          <span>
            {e.first_name} {e.last_name}
          </span>
        ),
        Email: <span>{e.email}</span>,
        Mobile: (
          <span>
            +{e.country_code} {e.mobile}
          </span>
        ),
        Status: (
          <span style={{ color: e.status === "active" ? "green" : "red" }}>
            {e.status}
          </span>
        ),
      }));

      setStaffList(formattedData);
    } catch (error) {
      console.error(error);
    }

    setLoading(false);
  };

  return (
    <Fragment>
      {loading && <Transparentspinner />}

      <Breadcrumbs mainTitle="Staff" parent="Administration" title="Staff" />

      <Card>
        <CardHeader>
          <H3>Staff Table</H3>
        </CardHeader>

        {/* 🔍 Search */}
        <div
          style={{
            paddingLeft: "22px",
            marginRight: "22px",
            marginBottom: "-20px",
          }}
        >
          <div style={{ display: "flex", alignItems: "center", float: "left" }}>
            <SearchList updateSearchKeyword={updateSearchKeyword} />
            <button
              className="btn btn-primary mb-3 ms-2"
              onClick={() => setSearchKeyword(tempSearch)}
            >
              Filter
            </button>
          </div>
          <div style={{ float: "right" }}>
            <Btn
              attrBtn={{
                color: "primary",
                onClick: () =>
                  navigate(
                    `${process.env.PUBLIC_URL}/master-records/staff-add`,
                  ),
              }}
            >
              Add
            </Btn>
          </div>
          <div style={{ clear: "both" }}></div>
        </div>

        <CardBody>
          <div className="order-history table-responsive">
            <DataTable
              data={staffList}
              columns={StaffColumns(ActionCell)}
              pagination
              highlightOnHover
              striped
              responsive
            />
          </div>
        </CardBody>
      </Card>
    </Fragment>
  );
};

export default StaffList;
